<template>
  <div class="px-3 py-2">
    <!-- Botón de inicio con el estilo exacto de Inventory.vue -->
    <div class="d-flex mb-4 mt-2">
      <div class="btn-home ms-auto">
        <button type="button" class="btn btn-outline-main" @click="returnHome">
          <i class="fas fa-home-lg-alt"></i> Inicio
        </button>
      </div>
    </div>

    <div id="div-modal-stock" class="d-flex justify-content-center">
      <div id="div-stock" class="card w-100">
        <div class="card-header text-white h4 text-center" style="background: #900052">
          <strong>ESTADÍSTICAS DE STOCK</strong>
        </div>

        <div class="card-body w-100">
          <div class="row">
            <!-- Panel Izquierdo: Filtros -->
            <div class="col-xl-3 col-lg-4 col-md-12 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body bg-light">

                  <!-- Almacén -->
                  <div class="mb-4">
                    <label class="form-label font-weight-bold text-secondary">ALMACÉN</label>
                    <v-select
                      class="text-dark bg-white"
                      label="name"
                      :options="dataAlmacen"
                      placeholder="- Seleccionar -"
                      v-model="selectedAlma"
                      :reduce="(name) => name.id"
                      @input="mtdGetData"
                    >
                      <template slot="no-options">
                        No hay Almacén para la búsqueda.
                      </template>
                    </v-select>
                  </div>

                  <!-- Buscador -->
                  <div class="mb-4">
                    <label class="form-label font-weight-bold text-secondary">BUSCADOR</label>
                    <div class="input-group input-group-sm">
                      <span class="input-group-text bg-white"><i class="fas fa-search"></i></span>
                      <input type="text" class="form-control" v-model="searchQuery" placeholder="Nombre del producto..." />
                    </div>
                  </div>

                  <!-- Guía de Stock (Intuitiva) -->
                  <div class="mb-4">
                    <label class="form-label font-weight-bold text-secondary">FILTRAR POR ESTADO</label>
                    <p class="text-muted text-xs mb-2"><i class="fas fa-hand-pointer"></i> Haz clic en un estado para filtrar:</p>
                    <div class="list-group cursor-pointer">
                      <div class="list-group-item d-flex align-items-center justify-content-between"
                           :class="{'active-filter': filterColor === 'green'}"
                           @click="filterColor = 'green'">
                        <div>
                          <span class="badge bg-success me-2" style="width: 15px; height: 15px; border-radius: 50%;">&nbsp;</span>
                          <span class="font-weight-bold">Stock Suficiente</span>
                        </div>
                        <i class="fas fa-filter text-muted" v-if="filterColor !== 'green'"></i>
                        <i class="fas fa-check text-success" v-else></i>
                      </div>
                      <div class="list-group-item d-flex align-items-center justify-content-between"
                           :class="{'active-filter': filterColor === 'yellow'}"
                           @click="filterColor = 'yellow'">
                        <div>
                          <span class="badge bg-warning me-2" style="width: 15px; height: 15px; border-radius: 50%;">&nbsp;</span>
                          <span class="font-weight-bold">Próximo al mínimo (Alerta)</span>
                        </div>
                        <i class="fas fa-filter text-muted" v-if="filterColor !== 'yellow'"></i>
                        <i class="fas fa-check text-warning" v-else></i>
                      </div>
                      <div class="list-group-item d-flex align-items-center justify-content-between"
                           :class="{'active-filter': filterColor === 'red'}"
                           @click="filterColor = 'red'">
                        <div>
                          <span class="badge bg-danger me-2" style="width: 15px; height: 15px; border-radius: 50%;">&nbsp;</span>
                          <span class="font-weight-bold">Stock Mínimo o Crítico</span>
                        </div>
                        <i class="fas fa-filter text-muted" v-if="filterColor !== 'red'"></i>
                        <i class="fas fa-check text-danger" v-else></i>
                      </div>
                      <div class="list-group-item d-flex align-items-center justify-content-between bg-white border-top"
                           :class="{'active-filter': filterColor === 'all'}"
                           @click="filterColor = 'all'">
                        <div>
                          <i class="fas fa-list me-2 text-secondary"></i>
                          <span class="font-weight-bold">Mostrar Todos</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Tipo de Producto -->
                  <div class="mb-2">
                    <label class="form-label font-weight-bold text-secondary">TIPO DE PRODUCTO</label>
                    <div class="d-flex flex-wrap gap-2">
                      <button class="btn btn-sm" :class="filterType === 'all' ? 'btn-main' : 'btn-outline-secondary'" @click="filterType = 'all'">Todos</button>
                      <button class="btn btn-sm" :class="filterType === 1 ? 'btn-main' : 'btn-outline-secondary'" @click="filterType = 1">Medicamentos</button>
                      <button class="btn btn-sm" :class="filterType === 2 ? 'btn-main' : 'btn-outline-secondary'" @click="filterType = 2">Insumos</button>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- Panel Derecho: Grid de Productos con Scroll -->
            <div class="col-xl-9 col-lg-8 col-md-12">
              <div class="scroll-container pr-2">
                <div v-if="loading" class="text-center py-5">
                  <i class="fas fa-spinner fa-spin fa-2x text-main"></i>
                  <p class="mt-2 text-muted">Cargando inventario...</p>
                </div>
                
                <div v-else-if="filteredProducts.length === 0" class="text-center py-5 bg-white rounded shadow-sm border">
                  <h5 class="text-muted"><i class="fas fa-box-open fa-2x mb-3 text-secondary"></i><br>No se encontraron productos con estos filtros</h5>
                </div>

                <div v-else class="row">
                  <div v-for="prod in filteredProducts" :key="prod.id" class="col-xl-4 col-lg-6 col-md-6 mb-4">
                    <div class="card h-100 shadow-sm border-0 card-product">
                      <!-- Cabecera de color según estado -->
                      <div :class="['card-header text-white text-center py-3 border-0', getColorClass(prod)]">
                        <strong class="text-uppercase" style="font-size: 0.85rem; line-height: 1.2;">{{ prod.product_name }}</strong>
                      </div>
                      <div class="card-body text-center d-flex flex-column justify-content-center bg-white">
                        <h1 class="font-weight-bold mb-0 text-dark" style="font-size: 2.5rem;">{{ prod.current_stock }}</h1>
                        <small class="text-muted text-uppercase font-weight-bold mb-2">{{ prod.unit_name || 'UNIDAD' }}</small>
                        <p class="text-muted mb-1" style="font-size: 0.8rem;">Stock Mínimo: {{ prod.minimum_stock }}</p>
                        <hr class="w-75 mx-auto my-2">
                        <span class="badge" :class="getBadgeClass(prod)">{{ getStockLabel(prod) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "StockStatistics",
  data() {
    return {
      loading: false,
      searchQuery: "",
      filterColor: "all", // all, green, yellow, red
      filterType: "all", // all, 1, 2
      selectedAlma: null,
      dataAlmacen: [],
      productosRaw: [],
    };
  },
  computed: {
    filteredProducts() {
      return this.productosRaw.filter((prod) => {
        // 1. Filtro por texto
        const matchesSearch = prod.product_name.toLowerCase().includes(this.searchQuery.toLowerCase());
        
        // 2. Filtro por tipo
        let matchesType = true;
        if (this.filterType !== 'all') {
            matchesType = (prod.type || 1) == this.filterType;
        }

        // 3. Filtro por color/estado
        const status = this.calculateStatus(prod);
        const matchesColor = this.filterColor === "all" || status === this.filterColor;

        return matchesSearch && matchesType && matchesColor;
      });
    }
  },
  created() {
    this.vercampus();
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    vercampus() {
      // Se usa el mismo endpoint que en Inventory.vue para consistencia
      this.get({
        url: this.$store.getters.get__url + "/Kardex/filterAlmacen/" + this.$store.getters.get__campus,
        token: this.$store.getters.get__token,
      })
      .then((response) => {
        this.dataAlmacen = response.data;
      })
      .catch((errors) => {
        console.log(errors);
      });
    },
    mtdGetData() {
      if (!this.selectedAlma) return;
      this.loading = true;
      this.productosRaw = [];
      
      this.post({
        url: this.$store.getters.get__url + "/logistics/stock/consolidado",
        token: this.$store.getters.get__token,
        params: { almacen: this.selectedAlma }
      }).then(res => {
        this.productosRaw = res.data || [];
      }).catch(err => {
        console.log(err);
        // Datos de prueba para que veas el diseño mientras conectas el backend
        this.productosRaw = [
            { id: 1, product_name: 'REJILLAS PLASTICA 17 X 23 CM CHICAS', current_stock: 178, minimum_stock: 50, type: 2, unit_name: 'UNIDAD' },
            { id: 2, product_name: 'MANGUERA GN INUNSUR 1.5 M', current_stock: 112, minimum_stock: 100, type: 2, unit_name: 'UNIDAD' },
            { id: 3, product_name: 'TUBERIA PEX AL PEX 100M', current_stock: 101, minimum_stock: 20, type: 2, unit_name: 'UNIDAD' },
            { id: 4, product_name: 'CHAPA 103 LENGUETA CORTA', current_stock: 88, minimum_stock: 90, type: 2, unit_name: 'UNIDAD' },
            { id: 5, product_name: 'MANGUERA GN INUNSUR 0.6 M', current_stock: 50, minimum_stock: 10, type: 2, unit_name: 'UNIDAD' },
            { id: 6, product_name: 'TEE GRAFADO PEALPE 25X25', current_stock: 0, minimum_stock: 20, type: 2, unit_name: 'UNIDAD' },
        ];
      }).finally(() => {
        this.loading = false;
      });
    },
    calculateStatus(prod) {
      const current = parseFloat(prod.current_stock || 0);
      const min = parseFloat(prod.minimum_stock || 0);

      if (current === 0 || current < min) return 'red';
      if (current === min) return 'yellow'; 
      return 'green';
    },
    getColorClass(prod) {
      const status = this.calculateStatus(prod);
      if (status === 'red') return 'bg-danger';
      if (status === 'yellow') return 'bg-warning text-dark';
      return 'bg-success'; // <-- AHORA ES VERDE
    },
    getBadgeClass(prod) {
      const status = this.calculateStatus(prod);
      if (status === 'red') return 'bg-danger';
      if (status === 'yellow') return 'bg-warning text-dark';
      return 'bg-success';
    },
    getStockLabel(prod) {
      const status = this.calculateStatus(prod);
      if (status === 'red') return 'Stock Crítico';
      if (status === 'yellow') return 'Alerta Mínimo';
      return 'Stock Disponible';
    }
  },
};
</script>

<style scoped>
.scroll-container {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
}

.scroll-container::-webkit-scrollbar { width: 8px; }
.scroll-container::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
.scroll-container::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 4px; }
.scroll-container::-webkit-scrollbar-thumb:hover { background: #a8a8a8; }

.card-product {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.card-product:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}

.cursor-pointer { cursor: pointer; }
.gap-2 { gap: 0.5rem; }
.text-main { color: #900052; }

.btn-main {
  background-color: #900052;
  color: white;
  border: none;
}
.btn-main:hover {
  background-color: #70003f;
  color: white;
}

.list-group-item {
  border-left: 0;
  border-right: 0;
  padding: 0.6rem 1rem;
  transition: background 0.2s;
}
.list-group-item:hover {
  background-color: #f8f9fa;
}
.active-filter {
  background-color: #f1e4eb !important; /* Tono claro del color principal */
  border-left: 4px solid #900052 !important;
}
</style>